document.addEventListener("DOMContentLoaded", () => {
    let sliders = document.querySelectorAll('.colors-grid');
    sliders.forEach((slider) => {
        let objectSlider = new ColorsSlider(slider);
        objectSlider.init();
    });
});

class ColorsSlider {
    constructor(slider) {
        this.slider = slider;
        this.index = 0;
        this.animate = false;
    }

    init() {
        this.bindPagination();
        let that = this;
        window.onresize = function () {
            that.slide(0);
        }
    }

    slide(slideIndex) {
        if (this.animate) {
            return;
        }
        this.animate = true;

        this.slider.style.left = (slideIndex * -100) + '%';

        let that = this;
        setTimeout(function () {
            that.animate = false;
        }, 150);
    }

    bindPagination() {
        let paginations = this.slider.parentNode.parentNode.querySelectorAll('.pagination');
        paginations.forEach((pagination) => {
            let buttons = pagination.querySelectorAll('button');
            if (buttons.length > 0) {
                buttons[0].classList.add('active');
            }
            buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    this.setActiveButton(pagination, button);
                    this.slide(index);
                });
            })
        })
    }

    setActiveButton(pagination, button) {
        pagination.querySelector('.active').classList.remove('active');
        button.classList.add('active');
    }
}
